import {createSelector} from 'reselect';

import {UserPageState, workspacesSelectors} from './workspacesSlice';

export const makeSelectWorkspacesByKey = (queryKey: string) =>
    createSelector(
        [
            (state: UserPageState) => state.userPage.tabs.content.workspaces.queries[queryKey],
            (state: UserPageState) => workspacesSelectors.selectEntities(state),
        ],
        (query, entities) => {
            if (!query) {
                return {items: [], total: 0, status: 'idle' as const, error: undefined};
            }
            return {
                items: (query.ids ?? []).map((id: number) => entities[id]!),
                total: query.total,
                status: query.status,
                error: query.error,
            };
        },
    );

export const selectReceivedAt = (state: UserPageState, queryKey: string) =>
    state.userPage.tabs.content.workspaces.queries[queryKey]?.receivedAt;
